import _ from "lodash";
import React from "react";
import styled from "styled-components";

interface FlexLayoutProps {
    children: React.ReactNode;
    direction?: "row" | "column";
    justify?: "flex-start" | "flex-end" | "center" | "space-between" | "space-around" | "stretch";
    align?: "flex-start" | "flex-end" | "center" | "baseline" | "stretch";
    alignSelf?: "auto" | "flex-start" | "flex-end" | "center" | "baseline" | "stretch";
    textAlign?: "left" | "center" | "right";
    wrap?: "nowrap" | "wrap" | "wrap-reverse";
    grow?: number;
    shrink?: number;
    scrollable?: boolean | "vertical" | "horizontal" | "both";
    gap?: number | string;
    rowGap?: number | string;
    columnGap?: number | string;
    padding?: number | string;
    margin?: number | string;
    height?: number | string | "fill";
    width?: number | string | "fill";
    maxHeight?: string | number;
    maxWidth?: string | number;
    minHeight?: string | number;
    minWidth?: string | number;
    background?: string;
    color?: string;
    border?: string;
    borderRadius?: string;
    selected?: boolean;
    noHover?: boolean;
    clickable?: boolean;
    onClick?: () => void;
    visible?: boolean;
    style?: React.CSSProperties;
}

const StyledFlexLayout = styled.div<FlexLayoutProps>`
    pointer-events: all;
    position: relative;
    display: ${props => props.visible === false ? "none" : "flex"};
    flex-direction: ${props => props.direction};
    justify-content: ${props => props.justify};
    align-items: ${props => props.align};
    align-self: ${props => props.alignSelf};
    text-align: ${props => props.textAlign};
    ${props => props.wrap ? `flex-wrap: ${props.wrap};` : ""}
    ${props => _.isNumber(props.grow) ? `flex-grow: ${props.grow};` : ""}
    ${props => (_.isNumber(props.shrink) ? `flex-shrink: ${props.shrink};` : "")}
    overflow-x: ${props => !_.isBoolean(props.scrollable) && ["horizontal", "both"].includes(props.scrollable) ? "auto" : "hidden"};
    overflow-y: ${props => (_.isBoolean(props.scrollable) && props.scrollable) || (!_.isBoolean(props.scrollable) && ["vertical", "both"].includes(props.scrollable)) ? "auto" : "hidden"};
    ${props => props.gap ? `gap: ${_.isNumber(props.gap) ? `${props.gap}px` : props.gap};` : ""}
    ${props => props.rowGap ? `row-gap: ${_.isNumber(props.rowGap) ? `${props.rowGap}px` : props.rowGap};` : ""}
    ${props => props.columnGap ? `column-gap: ${_.isNumber(props.columnGap) ? `${props.columnGap}px` : props.columnGap};` : ""}
    padding: ${props => _.isNumber(props.padding) ? `${props.padding}px` : props.padding};
    margin: ${props => _.isNumber(props.margin) ? `${props.margin}px` : props.margin};
    width: ${props => (props.width === "fill" ? "100%" : _.isNumber(props.width) ? `${props.width}px` : props.width)};
    height: ${props => (props.height === "fill" ? "100%" : _.isNumber(props.height) ? `${props.height}px` : props.height)};
    max-width: ${props => _.isNumber(props.maxWidth) ? `${props.maxWidth}px` : props.maxWidth};
    max-height: ${props => _.isNumber(props.maxHeight) ? `${props.maxHeight}px` : props.maxHeight};
    min-width: ${props => _.isNumber(props.minWidth) ? `${props.minWidth}px` : props.minWidth};
    min-height: ${props => _.isNumber(props.minHeight) ? `${props.minHeight}px` : props.minHeight};
    ${props => props.background ? `background: ${props.background};` : ""}
    ${props => props.color ? `color: ${props.color};` : ""}
    border: ${props => props.border || "none"};
    border-radius: ${props => props.borderRadius || "0"};
    ${props => props.clickable ? "cursor: pointer;" : ""}
    ${props => props.selected ? `background: rgb(254, 254, 254); border: solid 2px #11a9e2; box-shadow: 0px 0px 20px rgba(0,0,0,.05);` : ""}
    ${props => !props.selected && !props.noHover && props.clickable && props.onClick ? `&:hover { background: rgb(254, 254, 254); border: solid 1px #ccc; box-shadow: 0px 0px 20px rgba(0,0,0,.05); }` : ""}
`;

export function FlexLayout({ children, ...props }: FlexLayoutProps) {
    return <StyledFlexLayout {...props}>{children}</StyledFlexLayout>;
}
